import * as Sentry from '@sentry/react'
import { MetricsApi } from 'conversations/api'
import { Subject } from 'rxjs'
import { bufferTime, filter } from 'rxjs/operators'
import { isProduction } from 'shared/utils/environment'

export type MetricType = 'counter' | 'gauge' | 'statsMonitor' | 'timer' | 'bucket'
export const PERFORMANCE_BUCKETS = '100,250,500,750,1000,2000'

export interface MetricPayload {
  metric: string
  value: number
  dimensions: {
    type: MetricType
    [key: string]: string
  }
}

export const sendMetricToSentry = (metric: string, data: number, unit = 'millisecond') => {
  const transaction = Sentry.getCurrentHub()?.getScope()?.getTransaction()
  transaction?.setMeasurement(metric, data, unit)
}

export const measureInteraction = (metric: string, sendToSentry = false) => {
  const startTimestamp = performance.now()
  if (!isProduction) {
    console.debug('START interaction', metric)
  }
  return {
    end() {
      const endTimestamp = performance.now()
      const duration = endTimestamp - startTimestamp
      if (isProduction) {
        write(metric, duration, 'bucket', {
          buckets: PERFORMANCE_BUCKETS,
        })
        sendToSentry && sendMetricToSentry(metric, duration)
      } else {
        console.debug(`${metric} The interaction took`, duration, 'ms')
      }
    },
  }
}

const metricsBuffer = new Subject<MetricPayload>()

metricsBuffer
  .asObservable()
  .pipe(
    bufferTime(10000),
    filter((items) => items.length > 0)
  )
  .subscribe((metrics) => MetricsApi.post('/monitoring/metrics/add/bulk', metrics))

export const write = (
  metric: string,
  value: number,
  type: MetricType,
  dimensions: { [key: string]: string } = {}
) => {
  metricsBuffer.next({
    metric,
    value,
    dimensions: {
      type,
      ...dimensions,
    },
  })
}

export default {
  write,
}
